import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";

export function Brand({ themeData }) {
  const uiService = useHtmlClassService();

  const handleMenuScrollToTop = ()=>{
    try{
      document.getElementById("kt_aside_menu").scrollTo(0,0);
    }catch(e){
      console.log("handleMenuScrollToTop error:", e)
    }
  }

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo(),
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Brand */}
      <div className={``} id="" style={{ background: "#fff", height: "60px" }}>
        {/* begin::Logo */}
        <Link
          to=""
          className="d-flex mx-auto brand-logo p-1"
          style={{ height: "60px", width: "100px" }}
          onClick={handleMenuScrollToTop}
        >
          <img
            alt="logo"
            className="img-fluid"
            style={{ height: "100%" }}
            src={`${themeData?.mainLogo}`}
          />
        </Link>
        {/* end::Logo */}

        {layoutProps.asideSelfMinimizeToggle && (
          <>
            {/* begin::Toggle */}
            {/*<button
              className="brand-toggle btn btn-sm px-0"
              id="kt_aside_toggle"
            >
              <span className="svg-icon svg-icon-xl">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Navigation/Angle-double-left.svg"
                  )}
                />
              </span>
                  </button>*/}
            {/* end::Toolbar */}
          </>
        )}
      </div>
      {/* end::Brand */}
    </>
  );
}
